import React from "react";
import DrawerItems from "./DrawerItems";

function Drawer({ isOpen, onClose }) {
  return (
    <div className="drawer-content drawer-end">
      <input
        id="my-drawer-4"
        type="checkbox"
        className="drawer-toggle"
        checked={isOpen}
      />
      <div className="drawer-side z-998">
        <label
          htmlFor="my-drawer-4"
          aria-label="close drawer"
          className="drawer-overlay"
          onClick={onClose}
        ></label>
        <ul className="menu dark:bg-cyan-900 bg-blue-400 text-base-content min-h-full w-80 p-4">
          <DrawerItems onClick={onClose} />
        </ul>
      </div>
    </div>
  );
}

export default Drawer;
